import React, { memo } from 'react';
import { CopyIcon } from './Icons';
import { BUTTON_THEMES } from '../config/themes';
import Tooltip from './Tooltip';

const CopyButton = memo(({ content, theme = 'default', className = "", title = "Copy to Clipboard" }) => {
  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(content || '');
  };

  const currentTheme = BUTTON_THEMES[theme] || BUTTON_THEMES.default;

  return (
    <Tooltip tooltip={title}>
      <button
        onClick={handleCopy}
        className={`p-1.5 rounded transition-all ${currentTheme.bg} ${currentTheme.text} border ${currentTheme.border} ${className} active:scale-90`}
      >
        <CopyIcon />
      </button>
    </Tooltip>
  );
});

CopyButton.displayName = 'CopyButton';

export default CopyButton;